/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { b2b_v1_portfolio_builder_core_Position } from './b2b_v1_portfolio_builder_core_Position';
export type b2b_v1_portfolio_builder_portfolio_template_CreatePortfolioTemplate = {
    name: string;
    organization: string;
    positions?: Array<b2b_v1_portfolio_builder_core_Position>;
    share_scope?: b2b_v1_portfolio_builder_portfolio_template_CreatePortfolioTemplate.share_scope;
};
export namespace b2b_v1_portfolio_builder_portfolio_template_CreatePortfolioTemplate {
    export enum share_scope {
        USER = 'user',
        ORGANIZATION = 'organization',
    }
}

